import { BuenoIcon } from '@shared/services/icon/bueno-icon.types';

export type SidebarInfoBubbleKey = 'referral' | 'directDebit';

export interface ISidebarItem {
  name: string;
  url: string;
  icon: BuenoIcon;
  remoteLink?: boolean;
  hideIfOnlyProperties?: boolean;
  infoBubbleKey?: SidebarInfoBubbleKey;
}

export const SIDEBAR_NAVIGATION_LIST: ISidebarItem[] = [
  {
    name: 'HOME',
    url: '/home',
    icon: 'bueno-initial',
    hideIfOnlyProperties: false,
  },
  {
    name: 'TRANSFERS.TRANSFERS',
    url: '/transactions',
    icon: 'bueno-transaction',
    hideIfOnlyProperties: true,
  },
  {
    name: 'CARDS',
    url: '/bueno-cards',
    icon: 'bueno-credit-card',
    hideIfOnlyProperties: true,
  },
  {
    name: 'DIRECT_DEBITS.FORM.TITLE',
    url: '/direct-debit',
    icon: 'bueno-debit',
    hideIfOnlyProperties: true,
    infoBubbleKey: 'directDebit',
  },
  {
    name: 'PROPERTY.PROPERTIES',
    url: '/properties',
    icon: 'bueno-building',
    hideIfOnlyProperties: false,
  },
];

export const BOTTOM_NAVIGATION_LIST: ISidebarItem[] = [
  {
    name: 'FOOTER.WHAT_NEW',
    url: '/account/whats-new',
    icon: 'bueno-bell',
  },
  {
    name: 'FOOTER.SUPPORT',
    url: 'https://getbueno.com/help/',
    remoteLink: true,
    icon: 'bueno-chat',
  },
];
